/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import { EuiButtonIcon } from '@elastic/eui'

import type { TrafficFilterRulesetInfo } from '@modules/cloud-api/v1/types'
import { useDeleteTrafficFilterRulesetAssociationMutation } from '@modules/cloud-lib/networkSecurity/hooks'

type Props = {
  deploymentId: string | undefined // sanity
  ruleset: TrafficFilterRulesetInfo
}

const RemoveButton: React.FunctionComponent<Props> = ({ deploymentId, ruleset }) => {
  const { formatMessage } = useIntl()

  const { mutate: deleteTrafficFilterAssociation } =
    useDeleteTrafficFilterRulesetAssociationMutation()

  if (!deploymentId) {
    return null // sanity
  }

  return (
    <EuiButtonIcon
      color='danger'
      iconType='cross'
      aria-label={formatMessage(
        { id: 'deploymentNetworkSecurity.list.remove', defaultMessage: 'Remove {name}' },
        { name: ruleset.name },
      )}
      onClick={() =>
        deleteTrafficFilterAssociation({
          rulesetId: ruleset.id,
          association: { entity_type: 'deployment', id: deploymentId },
        })
      }
    />
  )
}

export default RemoveButton
